<nav class="navbar navbar-default navbar-static-top img-fluid" role="navigation"> 
	<div class="app-banner">
		<div class="logo-container">
			<div class="row logo-row">
				<div class="logo-image-left col"></div>
				<div class="logo-image-right col"></div>
			</div>
			<div class="logo-image">
			</div>
		</div>
		
	</div>
	<button type="button" class="navbar-toggle" data-target="#navbar" data-toggle="collapse">
		<span class="sr-only">Toggle navigation</span>
		<span class="icon-bar"></span>
		<span class="icon-bar"></span>
		<span class="icon-bar"></span>
	</button>
	<div class="navbar-collapse collapse navbar-responsive-collapse" id="navbar"></div>
</nav>
<div class=" backpanel">
	<div class="inner-backpanel">
		<router-outlet></router-outlet>
	</div>
</div>
<div class="working-overlay" *ngIf="messageService.isBusy" (dblclick)="messageService.isBusy = false;">
	<mat-card cdkDrag>
		<div class="align-items-center">
			<mat-progress-bar mode="indeterminate" style="margin: 18px 0px;"></mat-progress-bar>
		</div>
		<div class="text-center">
			<div style="margin: 10px 43px">Working... Please wait</div>
		</div>
	</mat-card>
</div>
<simple-notifications [options]="messageService.options"></simple-notifications>